// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiCreateMentionedWave } from '../models/ApiCreateMentionedWave';
import { ApiDropMedia } from '../models/ApiDropMedia';
import { ApiQuotedDrop } from '../models/ApiQuotedDrop';
import { HttpFile } from '../http/http';

export class ApiCreateDropPart {
    'content'?: string | null;
    'quoted_drop'?: ApiQuotedDrop | null;
    'mentioned_waves'?: Array<ApiCreateMentionedWave>;
    'media': Array<ApiDropMedia>;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "content",
            "baseName": "content",
            "type": "string",
            "format": ""
        },
        {
            "name": "quoted_drop",
            "baseName": "quoted_drop",
            "type": "ApiQuotedDrop",
            "format": ""
        },
        {
            "name": "mentioned_waves",
            "baseName": "mentioned_waves",
            "type": "Array<ApiCreateMentionedWave>",
            "format": ""
        },
        {
            "name": "media",
            "baseName": "media",
            "type": "Array<ApiDropMedia>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiCreateDropPart.attributeTypeMap;
    }

    public constructor() {
    }
}
